const Button = ({ title, color, background, type, cliclHandler, disabled }) => {
  return (
    <>
      <button
        style={{
          color: "white",
          padding: "10px",
          cursor: "pointer",
          border: "none",
          outline: "none",
          background: `${background ? background : "crimson"}`,
          borderRadius: "5px",
        }}
        disabled={disabled}
        type={type}
        onClick={cliclHandler}
      >
        {title}
      </button>
    </>
  );
};

export default Button;
